module.exports = (__webpack_require__(4))(340);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/change-emitter/lib/index.js from dll-reference carbon.vendor
// module id = 22
// module chunks = 0